import CookiePolicy from "../components/CookiePolicy/CookiePolicy";

const CookiePolicyPage = () => {
  return <CookiePolicy />;
};

export default CookiePolicyPage;
